import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PackageCreationFiltering, PackageCreationAddEdit,PacakgePasswordChange } from './Pages';

export const PackageCreationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PackageCreationFiltering} />
        <Route exact path = {`${match.path}/AddEdit`} component={PackageCreationAddEdit} />
        <Route exact path = {`${match.path}/PasswordChange`} component={PacakgePasswordChange} />
    </Fragment>
)